import { InMemoryCache } from '@apollo/client/cache';
import { ApolloClient, createHttpLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import config from '../common/config';
import { getSha256 } from '../common/helpers/utility/sha256';

export function createApolloClient(initialState, ssr) {
  // The `ctx` (NextPageContext) will only be present on the server.
  // use it to extract auth headers (ctx.req) or similar.
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${JSON.stringify(
            message,
          )}, Location: ${JSON.stringify(locations)}, Path: ${path}`,
        ),
      );

    if (networkError) {
      // Check if error response is JSON
      try {
        JSON.parse(networkError.bodyText);
      } catch {
        // If not replace parsing error message with real one
        networkError.message = networkError.bodyText;
      } finally {
        console.log(`[Network error]:`, networkError);
      }
    }
  });

  const link = createPersistedQueryLink({ sha256: getSha256() })
    .concat(errorLink)
    .concat(
      createHttpLink({
        uri: config.apiUrl,
        credentials: ssr ? 'same-origin' : 'include',
      }),
    );

  return new ApolloClient({
    connectToDevTools: true,
    ssrMode: ssr,
    link,
    cache: new InMemoryCache().restore(initialState),
  });
}
